import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { HttpClienteService } from '../http-cliente.service';
@Injectable({
  providedIn: 'root'
})
export class PartnersALIService {
  private readonly url = environment.apiURL;
  constructor(
    private readonly _http: HttpClienteService,
  ) { }

  getAliPartnersFiles() {
    const query = `${this.url}/wcl-document/get-ali-socios-files`;
    return this._http.get(query);
  }
   getValueOfferByCods(obj) {
    const query = `${this.url}/wcl-document/value-offer-by-code?code=${obj.code}&sector=${obj.sector}`;
    return this._http.get(query);
  }
   getOfferSummaryByCode(obj) {
    const query = `${this.url}/wcl-document/value-offer-summary-by-code?code=${obj.code}&sector=${obj.sector}`;
    return this._http.get(query);
  }
}
